import { render, staticRenderFns } from "./SignUpPage.vue?vue&type=template&id=5721431c"
import script from "./SignUpPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUpPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SignUpPage.vue?vue&type=style&index=0&id=5721431c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports